<template>
    <div>
        <div class="mt55">
            <div class="w1200" v-show="isShow">
                <div class="head clearfix">
                    <HT text="flfg" class="fl" style="margin-top:20px"></HT>
                    <div class="fr bread clearfix">
                        <div class="fl" style="margin-right:15px;color: #064186">当前位置:</div>
                        <div class="fl">
                            <el-breadcrumb separator-class="el-icon-arrow-right">
                                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                                <el-breadcrumb-item :to="{ path: '/news/qyxw' }">企业动态</el-breadcrumb-item>
                                <el-breadcrumb-item :to="{ path: '/news/flfg' }">法律法规</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="title">
                        {{ list[0].title }}
                    </div>
                    <div class="date">
                        来源：{{ list[0].from }} &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp日期：{{ list[0].date }}
                    </div>
                    <div class="contentText" v-html="list[0].text">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/assets/utils/request'
import HT from '@/components/h2.vue'

export default {
    data() {
        return {
            list: [],
            isShow: true,
            query:""
        }
    },
    components: {
        HT
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/news/flfgxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data.filter(function(item){
                            return item.id == that.query
                        })
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        },
        getQuery() {
            this.$data.query = this.$route.query.id
        }
    },
    mounted() {
        this.getQuery()
        this.getList()
        this.$parent.isShow = false
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .title{
        text-align: center;
        margin-top: 40px;
        font-size: 18px;
    }
    .date{
        text-align: center;
        margin-top: 30px;
        color: #909399;
    }
    .contentText{
        margin-top: 55px;
        margin-bottom: 140px;
        color: #666;
    }
    
</style>

<style>
    .contentText strong{
        margin: 15px 0;
        display: block;
    }
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
    b{
        font-weight: normal;
    }
</style>